export const VERIFY_TOKEN = 'VERIFY_TOKEN'
export const GET_NEW_TOKEN = 'GET_NEW_TOKEN'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD'
export const UPDATE_YOUR_PASSWORD = 'UPDATE_YOUR_PASSWORD'
export const LOGIN = 'LOGIN'
export const RESET_AUTH_STATE = 'RESET_AUTH_STATE'
export const REGISTER_USER = 'REGISTER_USER'
export const REQUEST_RESET_PASSWORD_INSTRUCTIONS = 'REQUEST_RESET_PASSWORD_INSTRUCTIONS'
export const REQUEST_NEW_REGISTRATION_EMAIL = 'REQUEST_NEW_REGISTRATION_EMAIL'
export const SESSION_HEALTH_CHECK = 'SESSION_HEALTH_CHECK'
export const LOGIN_WITH_SSO = 'LOGIN_WITH_SSO'
export const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS'
export const AUTH_TOKEN_VERIFY = 'AUTH_TOKEN_VERIFY'

